var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', _vm._l(_vm.statusMap, function (status, index) {
    return _c('a-tooltip', {
      key: index
    }, [_c('template', {
      slot: "title"
    }, [_vm._v(" " + _vm._s(status.title) + " ")]), _vm.auction.status && status.id < _vm.statusMap[_vm.auction.status].id ? _c('i', {
      staticClass: "text-success fe fe-check-circle"
    }) : _vm.auction.status && status.id == _vm.statusMap[_vm.auction.status].id ? _c('i', {
      staticClass: "text-primary fe fe-play-circle"
    }) : _c('i', {
      staticClass: "text-muted fe fe-circle"
    })], 2);
  }), 1);
}
var staticRenderFns = []

export { render, staticRenderFns }